import endpoints from "config/endpoints";
import { useCallback } from "react";
import { getEnvVar } from "utils/environment";
import useAxiosRequest from "./common/useAxiosRequest";

const useTitles = () => {
  const { data, loading, error, run } = useAxiosRequest({ globalError: false });

  const getTitles = useCallback(
    ({ produto, versao }) => {
      run({
        url: endpoints.titulos(produto, versao),
        method: "GET",
        headers: {
          cnpj: getEnvVar("CNPJ"),
        },
      });
    },
    [run]
  );

  return { data, loading, error, getTitles };
};

export default useTitles;
